import { render, staticRenderFns } from "./Compromisos.vue?vue&type=template&id=fa19fe56&scoped=true&"
var script = {}
import style0 from "./Compromisos.vue?vue&type=style&index=0&id=fa19fe56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa19fe56",
  null
  
)

export default component.exports